/**
 * Generate username variations from a person's name
 * Examples for "John Smith":
 * - john.smith
 * - jsmith
 * - john
 * - johns
 * - j.smith
 */
export function generateUsernameVariations(firstName: string, lastName: string): string[] {
  const first = firstName.toLowerCase().replace(/[^a-z]/g, '');
  const last = lastName.toLowerCase().replace(/[^a-z]/g, '');

  if (!first && !last) return [];
  if (!first) return [last];
  if (!last) return [first];

  const firstInitial = first[0];
  const lastInitial = last[0];

  const variations = [
    `${first}.${last}`,     // john.smith
    `${firstInitial}${last}`, // jsmith
    first,                   // john
    `${first}${lastInitial}`, // johns
    `${firstInitial}.${last}`, // j.smith
  ];

  // Filter out duplicates and empty strings
  return [...new Set(variations.filter(Boolean))];
}

/**
 * Format price in cents to display string
 */
export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/**
 * Generate a unique ID for an email account
 */
export function generateAccountId(username: string, domain: string): string {
  return `${username}-${domain}-${Date.now()}`;
}
